import styled from "styled-components"
import { media } from "../mediaStyles"
import margins from "../MarginContainer"

const size = {
  small: "16px",
  medium: "2.6em",
  large: "50px",
}

const sizeMobile = {
  small: "16px",
  medium: "2em",
  large: "35px",
}

const Title = styled.h1`
  position: relative;
  overflow-wrap: initial;
  z-index: ${props => (props.noZindex ? 0 : 10)};
  font-size: ${props =>
    props.size ? sizeMobile[props.size] : sizeMobile.large};
  display: block;
  font-family: Recife Text, serif;
  font-weight: 400;

  ${media.small`
  font-size: ${props => (props.size ? size[props.size] : size.large)};
  font-weight: 300;
  `};

  ${margins};
`

export default Title
